<template>
  <v-app>
    <v-app-bar
        app
        color="secondary"
        dense
        v-if="$route.name != 'Home'"
    >
      <v-row justify="center">
        <div class="headline"  @click="$router.push('/')" :style="{ cursor: 'pointer'}">{{ $t('title') }}</div>
      </v-row>
    </v-app-bar>

    <v-main>
      <router-view class=""/>
    </v-main>

    <v-footer
        padless
        elevation="2"
    >
      <v-row justify="center" class="text-center" no-gutters>
        <v-col>
          <v-card
              tile
              flat
              color="secondary"
          >
            <v-card-text>
              <span class="hidden-sm-and-down mx-2">&copy; Marktgemeinde Lustenau {{ new Date().getFullYear() }}</span>
              <div class="hidden-md-and-up my-2">&copy; Marktgemeinde Lustenau {{ new Date().getFullYear() }}</div>
              <span class="mx-2">
                <dialog-modal
                  title="Impressum"
                  btn-ok=""
                  btn-cancel="Schließen"
                  btn-cancel-icon=""
                  btn-ok-icon=""
                  :body="imprint"

              >Impressum</dialog-modal>
              </span>
              <span class="mx-2">
                <dialog-modal
                    title="Datenschutz"
                    btn-ok=""
                    btn-cancel="Schließen"
                    btn-cancel-icon=""
                    btn-ok-icon=""
                    :body="privacy"
                    max-width="80%"
                >Datenschutz
                </dialog-modal></span>

            </v-card-text>
            <!--        <v-card-text>-->
            <!--          <div>-->
            <!--            <v-btn icon>-->
            <!--              <v-icon>mdi-web</v-icon>-->
            <!--            </v-btn>-->
            <!--            <v-btn icon>-->
            <!--              <v-icon>mdi-instagram</v-icon>-->
            <!--            </v-btn>-->
            <!--            <v-btn icon>-->
            <!--              <v-icon>mdi-facebook</v-icon>-->
            <!--            </v-btn>-->
            <!--          </div>-->
            <!--        </v-card-text>-->

            <v-card-text class="caption">
              Made with
              <v-icon small>mdi-heart</v-icon>
              by <a class="text--white" style="color: white" href="https://www.limemotion.com" target="_blank">limemotion</a> - (v{{ appVersion }})
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>

import DialogModal from "./components/DialogModal";

import strings from "./lang/strings.json"

export default {
  name: 'App',
  components: {
    DialogModal
  },
  data: () => ({
    appVersion: process.env.VUE_APP_VERSION,
    imprint: strings.imprint,
    privacy: strings.privacy,
  }),
};
</script>

<style>
.previewSonggl {
  transform: rotate3d(-10, 11, -3, 10deg)
}
</style>
